export default __webpack_public_path__ + "locales/zh-CN/ChangePortalOwner.json?hash=c1e96389524e868653eda289d0b4ce43";